const DEFAULT_PALETTE = ['#e30613', '#cc0033']
const WINE_COLOR = '#630000'

const CONFETTI_TOGGLE_ICON_SRC =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAABF9JREFUeAHlm0+KG0cYxZ+dkJAQgyAQ8EBIQcDZJEQwOUAdIIHZZiWtvB1BDiDNPmBtk410A4XkAOUDxMjGB2iv7KUM9sbGpl2v1J8otadH/adKXcM8eLS61GrVr76v/nTTfQvxNLAeWv9cbIdFmSod96zwS+sn1g+tHxf7yYtA59bGOu9onmOEjxsoCWmEgazyqviP3qURF7TsDD2BKxwXtOwFjpjq7KMb9AfrR3uEyHoAIE/MDxBBHH3XAPJEzbopBJLCNn1ShfVTXOGGwPrQA3RQymlc5TVaKsUBqq4bD2RjAH1XuqsnqCmF69Vvq7xBzUFsGaMCv+Ob/D/86LZS9hu+zv/HaT6DigVtynC3S/sakVYvd/AJ7uJztxW9wnu8wBu3jSSNA2vvDHFauk8bXNEa1wWiqfVlwKu+KnSKO5Xf3cVnru//hXtd/sMIpPRhZX2GiLKDFWylbVPvL4Tu257Ncgtd+Vv2/RPrDtIoVmC3vYKouocvHJQ/aPmyI/bevo2s/c2XdlB7i1/wyH7/FB019ncY8qhpa0FzGyW39ctlavJTdpvGP+UGw9xCh6qDIein2IZaI4Km06nbXlxcuKnnsunn1yKyD4ublIzs3/jBbZ/bKes13iGQNIq05ofgER0Oh7nIgl96zBTfuej+awelExtViaxfFrhemsCzGMD0eDyuhLaD1bFhabe+jjYdaa1zXz40+/Kf+H4HJtNPRFh6QWATC3i5XDrQ1Wp1ML0FmrBsDGYAG+QPfHvlPN3Q7lo5iwGrlNpB8vNV6V2GltT27UPzYqPlQoSs4WH96C4Wi13ZIWgflkB2keIifB8ne8fJMS3rFh7Wj64PfAiaKUyQ6YHLRUa7Q5qHB5boNoWWvhujTtGA/ehylM6yzAGWj6vbp2MAZyFPWO67g8HAbUejUaP0lohz6XmKr/bKmQX+nZMGzggc7FYso7vZbBzAZDLZ+46RbtqnOYiV19k0yzhwtaijIfAyFDAr7ItR9RujKTQjzCmoPEp3iPA/BJ6EAhYgf6FRB5ppb4w5Rp+eEViHOJlEiRXn/mw2qwVNOOkGviJBk9VdMgWLrt93q6DLa2xpKJZLw/G3EYB3t1tMiOhSBGcUL4PmZz91JcoE9c/HS8sIsAaeOvVjia6kZhna79Ny3Hw+3zvmCB75wK3TWqIrkALP7dnZ2V5ECcooy9x8ZCuUZNqcSAClj/pzcSKgtJuOytJNT+RHlzDn5+e7BkgEVKxRIdPkRJKu6/V6L6qEZsQTAKUzXCHd5GTlqyKZWo4E0jm6ItMUOlFQeoEaUkjjwbOuztDgqZ5g6+sePUJDzQH0Xem2nqOlbtRjSxRXYBmA/JqYdVXoKIUb9OihD536w6WdHjmsUooDWesBqq7GSCPFuVao/bRdVylEeoCtpg16ettF47jRNkjo7ZaYjz0lA1qWwraPs4IhIPlCSdDR9xbiSV7F09i+jiev4anScc+wfe3uceEniPgq3gd9ilOGC73GJAAAAABJRU5ErkJggg=='

function parseColorsFromDataset(raw) {
  if (!raw || typeof raw !== 'string') {
    return null
  }
  try {
    const parsed = JSON.parse(raw)
    if (Array.isArray(parsed) && parsed.length > 0) {
      const filtered = parsed.filter(c => typeof c === 'string' && c.length > 0)
      if (filtered.length > 0) {
        return filtered
      }
    }
  } catch (e) {
    /* ignore */
  }
  return null
}

/**
 * @param {number} count
 * @param {string[]} palette at least one hex color
 */
function generateConfetti(count, palette) {
  const colors = palette.length ? palette : DEFAULT_PALETTE
  const sizes = [
    { width: 9.6, height: 14.4 },
    { width: 6, height: 9.6 },
    { width: 11.52, height: 17.28 },
  ]

  return Array.from({ length: count }, (_, i) => {
    const selectedSize = sizes[Math.floor(Math.random() * sizes.length)]
    const isWineRed = Math.random() < 0.2
    const selectedColor = isWineRed
      ? WINE_COLOR
      : colors[Math.floor(Math.random() * colors.length)]
    const sizeMultiplier = isWineRed ? 1.15 : 1

    return {
      id: i,
      x: Math.random() * 100,
      delay: Math.random() * 5,
      duration: (5 + Math.random() * 5) * 1.25,
      rotation: Math.random() * 360,
      rotationSpeed: (Math.random() - 0.5) * 1080,
      color: selectedColor,
      width: selectedSize.width * sizeMultiplier,
      height: selectedSize.height * sizeMultiplier,
      swing: (Math.random() - 0.5) * 180,
      wobble: Math.random() * 540,
      horizontalDrift: (Math.random() - 0.5) * 100,
    }
  })
}

function getAriaLabels() {
  const { confettiAriaHide, confettiAriaShow } = document.body.dataset
  return {
    hide: confettiAriaHide || 'Hide confetti',
    show: confettiAriaShow || 'Show confetti',
  }
}

function getHoverLabels() {
  const {
    confettiLabelActivate,
    confettiLabelDeactivate,
  } = document.body.dataset
  return {
    activate: (confettiLabelActivate || '').trim(),
    deactivate: (confettiLabelDeactivate || '').trim(),
  }
}

/**
 * Infinite confetti (WAAPI) + bottom-right visibility toggle.
 * data-confetti="1" on body; optional data-confetti-colors JSON array.
 * z-index: overlay 1020, toggle 1030 (above overlay, below typical modals).
 */
export function initConfetti() {
  if (document.body.dataset.confetti !== '1') {
    return
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return
  }

  if (typeof document.createElement('div').animate !== 'function') {
    return
  }

  const palette =
    parseColorsFromDataset(document.body.dataset.confettiColors) ||
    DEFAULT_PALETTE

  const pieceCount = window.matchMedia('(max-width: 767px)').matches ? 120 : 200

  const pieces = generateConfetti(pieceCount, palette)

  const overlay = document.createElement('div')
  overlay.className = 'confetti-overlay'
  overlay.setAttribute('aria-hidden', 'true')

  pieces.forEach(piece => {
    const el = document.createElement('div')
    el.className = 'confetti-piece'
    el.style.left = `${piece.x}vw`
    el.style.top = '-20px'
    el.style.width = `${piece.width}px`
    el.style.height = `${piece.height}px`
    el.style.backgroundColor = piece.color

    const r = piece.rotation
    const wobble = piece.wobble
    const rotEnd = r + wobble + piece.rotationSpeed

    el.animate(
      [
        {
          transform: `translate3d(0, 0, 0) rotate(${r}deg)`,
          opacity: 0.8,
        },
        {
          transform: `translate3d(${piece.swing}px, 60vh, 0) rotate(${
            r + wobble
          }deg)`,
          opacity: 1,
        },
        {
          transform: `translate3d(${piece.horizontalDrift}px, 120vh, 0) rotate(${rotEnd}deg)`,
          opacity: 0.6,
        },
      ],
      {
        duration: piece.duration * 1000,
        delay: piece.delay * 1000,
        iterations: Infinity,
        easing: 'linear',
        fill: 'both',
      }
    )

    overlay.appendChild(el)
  })

  const labels = getAriaLabels()
  const hoverLabels = getHoverLabels()
  let visible = true

  const btn = document.createElement('button')
  btn.type = 'button'
  btn.className = 'confetti-toggle'
  btn.setAttribute('aria-pressed', 'true')
  btn.setAttribute('aria-label', labels.hide)
  btn.innerHTML = `<span class="confetti-toggle__inner"><span class="confetti-toggle__label" aria-hidden="true"></span><img class="confetti-toggle__icon" src="${CONFETTI_TOGGLE_ICON_SRC}" alt="" decoding="async" aria-hidden="true"></span>`
  const labelEl = btn.querySelector('.confetti-toggle__label')

  function syncUi() {
    overlay.classList.toggle('confetti-overlay--hidden', !visible)
    btn.setAttribute('aria-pressed', visible ? 'true' : 'false')
    btn.setAttribute('aria-label', visible ? labels.hide : labels.show)
    btn.classList.toggle('confetti-toggle--dimmed', !visible)
    const hoverText = visible ? hoverLabels.deactivate : hoverLabels.activate
    if (labelEl) {
      labelEl.textContent = hoverText
    }
    btn.classList.toggle('confetti-toggle--has-hover-label', Boolean(hoverText))
  }

  btn.addEventListener('click', () => {
    visible = !visible
    syncUi()
  })

  syncUi()

  document.body.appendChild(overlay)
  document.body.appendChild(btn)
}
